import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s("Sincronizar Tablas en Bigquery") + " "),
      ]),
      _c(
        "actions-component",
        [
          _c(
            "template",
            { slot: "description" },
            [
              _c(VBreadcrumbs, {
                staticClass: "pa-0",
                attrs: { items: _vm.getBreadcrumbs },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        VCard,
        { staticClass: "mt-2 pa-2 pb-0" },
        [
          _c(
            VRow,
            {
              staticClass: "d-flex justify-content-center",
              attrs: { dense: "" },
            },
            [
              _c(
                VCol,
                { attrs: { sm: "10", md: "8", lg: "7" } },
                [
                  _c(
                    VForm,
                    {
                      ref: "form",
                      attrs: { "lazy-validation": "" },
                      model: {
                        value: _vm.valid,
                        callback: function ($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid",
                      },
                    },
                    [
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "3" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [_vm._v(_vm._s("Organización"))]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "8" } },
                            [
                              _c("organizacion-component", {
                                attrs: {
                                  show_all: false,
                                  custom_orgs: _vm.list_orgs,
                                  rules: _vm.rules_domain,
                                },
                                model: {
                                  value: _vm.company_domain,
                                  callback: function ($$v) {
                                    _vm.company_domain = $$v
                                  },
                                  expression: "company_domain",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "3" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [_vm._v(_vm._s(_vm.$t("my_tasks.project_id")))]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "8" } },
                            [
                              _c(VTextField, {
                                attrs: {
                                  outlined: "",
                                  required: "",
                                  placeholder: _vm.$t("my_tasks.project_id"),
                                  dense: "",
                                  disabled: _vm.isLoading,
                                  rules: _vm.rules,
                                },
                                model: {
                                  value: _vm.project_id,
                                  callback: function ($$v) {
                                    _vm.project_id = $$v
                                  },
                                  expression: "project_id",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "3" } },
                            [
                              _c(
                                VSubheader,
                                { staticClass: "font-weight-bold" },
                                [_vm._v(_vm._s(_vm.$t("my_tasks.dataset_id")))]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "8" } },
                            [
                              _c(VTextField, {
                                attrs: {
                                  outlined: "",
                                  required: "",
                                  placeholder: _vm.$t("my_tasks.dataset_id"),
                                  dense: "",
                                  disabled: _vm.isLoading,
                                  rules: _vm.rules,
                                },
                                model: {
                                  value: _vm.dataset_id,
                                  callback: function ($$v) {
                                    _vm.dataset_id = $$v
                                  },
                                  expression: "dataset_id",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "3" } },
                            [
                              _c(
                                VSubheader,
                                {
                                  staticClass: "font-weight-bold",
                                  staticStyle: { "padding-right": "0px" },
                                },
                                [_vm._v(_vm._s(_vm.$t("my_tasks.table_name")))]
                              ),
                            ],
                            1
                          ),
                          _c(
                            VCol,
                            { attrs: { cols: "8" } },
                            [
                              _c(VTextField, {
                                attrs: {
                                  outlined: "",
                                  required: "",
                                  placeholder: _vm.$t("my_tasks.table_name"),
                                  dense: "",
                                  disabled: _vm.isLoading,
                                  rules: _vm.rules,
                                },
                                model: {
                                  value: _vm.table_id,
                                  callback: function ($$v) {
                                    _vm.table_id = $$v
                                  },
                                  expression: "table_id",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            {
                              staticClass: "original-col",
                              attrs: { cols: "", sm: "12" },
                            },
                            [
                              _c(
                                VAlert,
                                {
                                  attrs: {
                                    color: _vm.colorFlag,
                                    type: _vm.colorAlert,
                                    dismissible: "",
                                  },
                                  model: {
                                    value: _vm.show_message,
                                    callback: function ($$v) {
                                      _vm.show_message = $$v
                                    },
                                    expression: "show_message",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.message))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VRow,
                        [
                          _c(
                            VFlex,
                            {
                              staticClass: "text-center pt-3",
                              attrs: { cols: "12" },
                            },
                            [
                              _c(
                                VBtn,
                                {
                                  staticClass: "mr-1",
                                  attrs: { outlined: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.limpiar()
                                    },
                                  },
                                },
                                [
                                  _c(VIcon, { staticClass: "md-16" }, [
                                    _vm._v("mdi-restart"),
                                  ]),
                                  _c("span", [_vm._v(_vm._s("Limpiar"))]),
                                ],
                                1
                              ),
                              _c(
                                VBtn,
                                {
                                  attrs: {
                                    color: "primary",
                                    disabled: _vm.isLoading,
                                  },
                                  on: { click: _vm.onSubmit2 },
                                },
                                [
                                  _c(VIcon, { staticClass: "md-16" }, [
                                    _vm._v("icon-search"),
                                  ]),
                                  _c("span", [_vm._v(_vm._s("Ping"))]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }